/* import __COLOCATED_TEMPLATE__ from './prism-overflow-button.hbs'; */
import Component from '@ember/component';
export default Component.extend({
  tagName: 'button',
  classNames: ['prism-overflow-button'],
  classNameBindings: ['isOpen:prism-overflow-button--open'],
  isOpen: false
});